// @flow
import styled, { css } from 'styled-components';

export const DaySelectorList = styled.ul`
    display: flex;
    justify-content: space-around;
`;

export const DaySelectorItemWeekDay = styled.span`
    color: ${({ theme }) => theme.mainBrandColor};
    display: block;
    font-size: 1.3rem;
    text-align: center;
`;

export const DaySelectorItemDayNumber = styled.span`
    cursor: pointer;
    display: flex;
    font-size: 1.3rem;
    height: 3rem;
    justify-content: center;
    margin-top: 0.75rem;
    text-align: center;
    transition: color 0.3s ease-in-out;
    width: 3rem;
    align-items: center;
    ${({ selected }) =>
        selected &&
        css`
            cursor: default;
            background-color: ${({ theme }) => theme.mainBrandColor};
            border-radius: 50%;
            color: white;
        `};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/day-selector/styles.js